import React from 'react';
import { AccountNav } from './AccountNav';
import { Link } from 'react-router-dom';

export const AccountPage = () => {
  return (
    <div className="container mx-auto md:flex grid grid-cols-1 gap-8 lg:px-9 px-4 my-12">
      <AccountNav />
      <div className="lg:w-3/4 md:w-2/3 min-h-[400px]">
        <div className="border rounded">
          <div className="flex gap-3 text-sm">
            <div className="p-4 font-medium"><span className="text-gray-400 font-light lg:inline-block  block">Order ID:</span> 1255885859</div>
            <div className="p-4 font-medium"><span className="text-gray-400 font-light lg:inline-block block">Order Date:</span> 16 Apr</div>
            <div className="p-4 font-medium ml-auto"><span className="text-gray-400 font-light lg:inline-block block">Total Price:</span> $ 98</div>
          </div>
          <hr />
          <div className="p-4">
            <div className="flex gap-2 items-center">
              <div className="border rounded-full p-1 border-gray-400">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 text-gray-500">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
                </svg>
              </div>
              <span className="text-orange-400 font-medium">Delivered Early Mon, 18 Apr</span>
            </div>
            <hr className="mt-3 mb-3" />
            <div className="md:flex flex-row gap-3">
              <img src="images/product-01.png" alt="product" className="w-48 h-max " />
              <div>
                <h4 className="text-gray-700">Lenskart Air LA Eyeglasses</h4>
                <h4 className="text-gray-600 font-light text-sm my-1">+ Hydrophobic Anti-Glare</h4>
                <p className="text-gray-400 font-light text-xs">Sold by Lenskart Solutions Pvt Ltd.</p>
                <h3 className="font-medium  mt-2">$ 98</h3>
              </div>
              <div className="ml-auto md:text-right text-left mt-2 md:mt-0">
                <span className="text-xs text-gray-400 font-light block">Return window closed on 18 May 2022</span>
                <Link to="#" className="text-cyan-500 text-sm hover:text-cyan-600 hover:underline">VIEW POLICY</Link>
              </div>
            </div>
            <hr className="mt-5 mb-3" />
            <div className="flex items-center">
              <div>
                <h3>Reorder in just 2 minutes</h3>
                <Link to="#" className="text-cyan-500 text-sm hover:text-cyan-600 hover:underline">1800-111-111</Link>
              </div>
              <div className="ml-auto">
                <Link to="#" className="rounded bg-cyan-500 py-2 text-white uppercase px-6 cursor-pointer inline-block">REORDER</Link>
              </div>
            </div>
            <hr className="mt-3 mb-3" />
            <div className="flex gap-4 text-gray-800 text-sm">
              <div><i className="fa fa-check text-cyan-500"></i> Size - 134 mm</div>
              <div><i className="fa fa-check text-cyan-500"></i> Power Submitted</div>
            </div>
            <div className="border rounded-t mt-2">
              <div className="bg-gray-100 p-2 text-sm">
                Surinder Kumar
                </div>
              <div className="p-2">
                <table class="table-auto w-full text-left text-sm leading-6">
                  <thead>
                    <tr>
                      <th className="font-normal"></th>
                      <th className="font-normal text-right">Spherical (SPH)</th>
                      <th className="font-normal text-right">Cylindrical (CYL)</th>
                      <th className="font-normal text-right">Axis (0-180)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="font-light">
                      <td className="font-normal">LEFT</td>
                      <td className="text-right">-0.25</td>
                      <td className="text-right">-0.50</td>
                      <td className="text-right">100</td>
                    </tr>
                    <tr className="font-light">
                      <td className="font-normal">RIGHT</td>
                      <td className="text-right">0.00</td>
                      <td className="text-right">-2.00</td>
                      <td className="text-right">65</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <hr className="my-6" />

          <div className="p-4">
            <div className="flex gap-2 items-center">
              <div className="border rounded-full p-1 border-gray-400">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 text-gray-500">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
                </svg>
              </div>
              <span className="text-orange-400 font-medium">Delivered Early Mon, 18 Apr</span>
            </div>
            <hr className="mt-3 mb-3" />
            <div className="md:flex flex-row gap-3">
              <img src="images/product-01.png" alt="product" className="w-48 h-max " />
              <div>
                <h4 className="text-gray-700">Lenskart Air LA Eyeglasses</h4>
                <h4 className="text-gray-600 font-light text-sm my-1">+ Hydrophobic Anti-Glare</h4>
                <p className="text-gray-400 font-light text-xs">Sold by Lenskart Solutions Pvt Ltd.</p>
                <h3 className="font-medium  mt-2">$ 98</h3>
              </div>
              <div className="ml-auto md:text-right text-left mt-2 md:mt-0">
                <span className="text-xs text-gray-400 font-light block">Return window closed on 18 May 2022</span>
                <Link to="#" className="text-cyan-500 text-sm hover:text-cyan-600 hover:underline">VIEW POLICY</Link>
              </div>
            </div>
            <hr className="mt-5 mb-3" />
            <div className="flex items-center">
              <div>
                <h3>Reorder in just 2 minutes</h3>
                <Link to="#" className="text-cyan-500 text-sm hover:text-cyan-600 hover:underline">1800-111-111</Link>
              </div>
              <div className="ml-auto">
                <Link to="#" className="rounded bg-cyan-500 py-2 text-white uppercase px-6 cursor-pointer inline-block">REORDER</Link>
              </div>
            </div>
            <hr className="mt-3 mb-3" />
            <div className="flex gap-4 text-gray-800 text-sm">
              <div><i className="fa fa-check text-cyan-500"></i> Size - 134 mm</div>
              <div><i className="fa fa-check text-cyan-500"></i> Power Submitted</div>
            </div>
            <div className="border rounded-t mt-2">
              <div className="bg-gray-100 p-2 text-sm">
                Surinder Kumar
                </div>
              <div className="p-2">
                <table class="table-auto w-full text-left text-sm leading-6">
                  <thead>
                    <tr>
                      <th className="font-normal"></th>
                      <th className="font-normal text-right">Spherical (SPH)</th>
                      <th className="font-normal text-right">Cylindrical (CYL)</th>
                      <th className="font-normal text-right">Axis (0-180)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="font-light">
                      <td className="font-normal">LEFT</td>
                      <td className="text-right">-0.25</td>
                      <td className="text-right">-0.50</td>
                      <td className="text-right">100</td>
                    </tr>
                    <tr className="font-light">
                      <td className="font-normal">RIGHT</td>
                      <td className="text-right">0.00</td>
                      <td className="text-right">-2.00</td>
                      <td className="text-right">65</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}